import * as React from 'react';
import WorkBasedLearningTypeApiService from '../../../api/WorkBasedLearningTypeApiService';
import Routes from '../../../config/Routes';
import FeatureFlag from '../../../consts/FeatureFlag';
import WorkBasedLearningTypeDTO from '../../../models/WorkBasedLearningTypeDTO';
import TableRequestDTO from '../../../models/TableRequestDTO';
import BaseDataTableState from '../../../redux/bases/BaseDataTableState';
import BaseFormProps from '../../../redux/bases/BaseFormProps';
import BaseFormState from '../../../redux/bases/BaseFormState';
import AuthorizationUtil from '../../../utils/AuthorizationUtil';
import DateTimeUtil from '../../../utils/DateTimeUtil';
import FileDownload from '../../../utils/FileDownload';
import HistoryUtil from '../../../utils/HistoryUtil';
import DataTable, { DataTableColumnProps, FilterType } from '../core/DataTable';
import DataTableButtonUtil from '../core/DataTableButtonUtil';

interface WorkBasedLearningTypeDataTableProps extends BaseFormProps {
}

interface WorkBasedLearningTypeDataTableState extends BaseDataTableState<WorkBasedLearningTypeDTO>, BaseFormState {
}

class WorkBasedLearningTypeDataTable extends React.Component<WorkBasedLearningTypeDataTableProps, WorkBasedLearningTypeDataTableState> {
  private _dataTable: DataTable<WorkBasedLearningTypeDTO> | undefined;

  constructor(props: WorkBasedLearningTypeDataTableProps) {
    super(props);
    this.state = {
    };

  }

  private getColumnDefinitions = () => {
    return [
      {
        title: 'Name',
        dataIndex: WorkBasedLearningTypeDTO.name,
        sorter: true,
        filterType: FilterType.Text
      }
    ] as DataTableColumnProps<any>[];
  };

  private openInstructionalLevel = (record: WorkBasedLearningTypeDTO) => {
    if (record.id) {
      HistoryUtil.push(Routes.generate(Routes.WORK_BASED_LEARNING_DETAILS, { id: record.id }, {}));
    }
  }

  private addWorkBaseLearningType = () => {
    HistoryUtil.push(Routes.generate(Routes.NEW_WORK_BASED_LEARNING_TYPE));
  }

  render() {
    const actionButtons = [];

    actionButtons.push(DataTableButtonUtil.Reset());
    actionButtons.push(
      DataTableButtonUtil.Export(
        (tableRequest: TableRequestDTO) => {
          this.setState({ exporting: true });
          return WorkBasedLearningTypeApiService.getWorkBasedLearningTypeDataTableExport(tableRequest).then(file => {
            this.setState({ exporting: false });
            FileDownload.downloadBase64StringAsFile(`Work_Based_Learning_Type_${DateTimeUtil.getDateStamp()}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', file ?? undefined);
          });
        },
        this.state.exporting
      )
    );

    if (AuthorizationUtil.isAuthorized([FeatureFlag.EDIT_WORK_BASED_LEARNING])) {
      actionButtons.push(DataTableButtonUtil.Default('New Work Based Learning Type', () => this.addWorkBaseLearningType()));
    }

    return (
      <>
        <DataTable
          ref={(element: any) => (this._dataTable = element)}
          onRowClick={this.openInstructionalLevel}
          serverSide={true}
          tableProps={{
            rowKey: 'id',
            scroll: { x: 500 }
          }}
          globalSearch={true}
          buttonBar={actionButtons}
          columns={this.getColumnDefinitions()}
          fetchData={{
            fetch: (requestState: TableRequestDTO) => WorkBasedLearningTypeApiService.getWorkBasedLearningTypeTableData(requestState)
          }}
          stateSaving={{ enabled: true, tableUniqueKey: 'work_based_learning_type_list' }} />
      </>
    );
  }
}

export default WorkBasedLearningTypeDataTable;
